package gr.tech.meetinggenie.sections

import androidx.compose.runtime.*
import com.varabyte.kobweb.compose.foundation.layout.Column
import com.varabyte.kobweb.compose.ui.Modifier
import com.varabyte.kobweb.compose.ui.graphics.Colors
import com.varabyte.kobweb.compose.ui.modifiers.*
import com.varabyte.kobweb.compose.ui.toAttrs
import com.varabyte.kobweb.silk.components.text.SpanText
import com.varabyte.kobweb.silk.style.toModifier
import gr.tech.meetinggenie.models.meeting.WeeklySummaryDTO
import gr.tech.meetinggenie.styles.*
import org.jetbrains.compose.web.attributes.InputType
import org.jetbrains.compose.web.attributes.placeholder
import org.jetbrains.compose.web.css.cssRem
import org.jetbrains.compose.web.css.px
import org.jetbrains.compose.web.dom.*

@Composable
fun WeeklySummaryInput(
    weeklySummary: WeeklySummaryDTO,
    onUpdate: (WeeklySummaryDTO) -> Unit,
) {
    Column(modifier = Modifier.fillMaxWidth().gap(16.px)) {

        // One-sentence summary — required
        Column(modifier = Modifier.fillMaxWidth().gap(4.px)) {
            Label(attrs = GeneralInputLabelStyle.toModifier().toAttrs()) {
                Text("One-sentence summary of your week")
                SpanText(
                    modifier = Modifier.color(Colors.Red).fontSize(0.8.cssRem).margin(left = 4.px),
                    text = "*"
                )
            }
            Input(
                type = InputType.Text,
                attrs = GeneralInputStyle.toModifier().fillMaxWidth().toAttrs {
                    value(weeklySummary.oneSentenceSummary)
                    onInput { event -> onUpdate(weeklySummary.copy(oneSentenceSummary = event.value)) }
                }
            )
        }

        // Top priority for next week — required
        Column(modifier = Modifier.fillMaxWidth().gap(4.px)) {
            Label(attrs = GeneralInputLabelStyle.toModifier().toAttrs()) {
                Text("Top priority for next week")
                SpanText(
                    modifier = Modifier.color(Colors.Red).fontSize(0.8.cssRem).margin(left = 4.px),
                    text = "*"
                )
            }
            Input(
                type = InputType.Text,
                attrs = GeneralInputStyle.toModifier().fillMaxWidth().toAttrs {
                    value(weeklySummary.topPriorityNextWeek)
                    onInput { event -> onUpdate(weeklySummary.copy(topPriorityNextWeek = event.value)) }
                }
            )
        }
    }
}
